import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Box.scss';

const Box = ({
  className = '',
  renderAs = 'div',
  children = null,
  padless = false,
  footer = false,
  body = false,
  flush = [],
  plain = false,
  thinPadding = false,
  grey = false,
  noBorders = false,
  ...props
}) => {
  const Element = renderAs;
  return (
    <Element
      {...props}
      className={classnames(
        'box',
        styles.box,
        className,
        {
          padless: !!padless,
          [styles.grey]: grey,
          [styles.plain]: plain,
          [styles.footer]: footer,
          [styles.body]: body,
          'has-thin-padding': thinPadding,
          noBorders,
        },
        flush.map((direction) => `flush-${direction}`),
      )}
    >
      {children}
    </Element>
  );
};

Box.propTypes = {
  grey: PropTypes.bool,
  footer: PropTypes.bool,
  body: PropTypes.bool,
  plain: PropTypes.bool,
  style: PropTypes.shape({}),
  flush: PropTypes.arrayOf(PropTypes.string),
  padless: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  noBorders: PropTypes.bool,
  thinPadding: PropTypes.bool,
  renderAs: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
};

export const BoxTitle = ({ rightComponent, label }) => {
  return (
    <div className={styles.boxTitleContainer}>
      <div className={styles.boxLabel}>{label}</div>
      <div className={styles.boxCloseAction}>{rightComponent}</div>
    </div>
  );
};

export default Box;
